import { requestJira } from '@forge/bridge';

const apiPath = '/rest/api/3';

class jiraExpression {
    getResponseJsonAndRejectIfError(response: Response) {
        if (response.status >= 300) {
            return response.json().then(json => Promise.reject(json));
        } else {
            return response.json();
        }
    }

    analyseJiraExpression(expression: string): Promise<string> {
        return requestJira(`${apiPath}/expression/analyse`, {
            method: 'POST',
            body: JSON.stringify({
                expression,
            }),
            headers: {
                'Content-Type': 'application/json',
            },
        }).then(response =>
            this.getResponseJsonAndRejectIfError(response)
                .then(response => response.value as string)
                .catch(response => response.errorMessages[0] as string)
        );
    }

    evaluateJiraExpression(expression: string, issueKey: string): Promise<string> {
        return requestJira(`${apiPath}/expression/evaluate`, {
            method: 'POST',
            body: JSON.stringify({
                context: {
                    issue: {
                        key: issueKey,
                    },
                },
                expression,
            }),
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
        }).then(response => this.getResponseJsonAndRejectIfError(response).then(response => response.value as string));
    }
}

export default new jiraExpression();
